/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'
import './index.scss'

import { ToastContainer } from 'react-toastify'

import Logo from '../../assets/svg/Logo.svg'
import Pic from '../../assets/pictures/Pic.png'
import Pic2 from '../../assets/pictures/Pic2.png'

import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.css'

import { Swiper, SwiperSlide } from 'swiper/react'

import { post } from '../../services/http.js'
import { notify } from '../../components/Toast'

import { useNavigate } from 'react-router-dom'

export default function index () {
  const navigate = useNavigate()

  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')

  const buttonHandler = async (e) => {
    e.preventDefault()
    if (userName.length < 5) {
      notify('error', 'نام کاربری وارد نشده است')
    }

    if (password.length < 5) {
      notify('error', 'پسوورد وارد نشده است')
    }

    if (userName.length >= 5 && password.length >= 5) {
      post('/api/auth/login', {
        email: userName,
        password: password
      }).then(respose => {
        localStorage.setItem('token', respose.data.data.token)
        localStorage.setItem('data', JSON.stringify(respose.data.data))
        notify('success', 'ورود')
        setTimeout(() => {
          navigate('/dashboard')
        }, 4000)
      }).catch(error => {
        console.log(error)
        if (error) {
          return notify('error', error.response.data.messageFa)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
    }
  }

  return (
    <div id='signIn'>
      <ToastContainer rtl />
      <section className='signIn_section'>
        <div className='logo'>
          <img src={Logo} alt='Logo' />
        </div>
        <div className='form_section'>
          <div className='title'>
            ورود
          </div>
          <div className='subtitle'>
            تمامی امکانات در اختیار شما
          </div>
          <form className='form'>
            <label className='label_userName' htmlFor=''>نام کاربری :</label>
            <input className='input_userName' placeholder='نام کاربری' type='text' name='userName' id='userName' onChange={e => setUserName(e.target.value)} />
            <small className='warningAlert'>نام کاربری اشتباه است</small>
            <label className='label_password' htmlFor=''>پسوورد :</label>
            <input className='input_password' placeholder='*******' type='password' name='password' id='password' onChange={e => setPassword(e.target.value)} />
            <small className='warningAlert'>پسوورد اشتباه است</small>
            <button className='button_form' onClick={buttonHandler}>ورود</button>
          </form>
          <section className='problem'>
            برای ورود به بخش مدیریت مشکل دارید : <a href='https://ham-team.ir'>کلیک کنید</a>
          </section>
        </div>
        <div className='copyright'>
          © تمامی حقوق برای ibills محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
        </div>
      </section>
      <section className='slider_section'>
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          className='mySwiper'
        >
          <SwiperSlide>
            <img src={Pic} alt='slideOnePic' />
          </SwiperSlide>
          <SwiperSlide>
            <img src={Pic2} alt='slideOnePic' />
          </SwiperSlide>
        </Swiper>
      </section>
    </div>
  )
}
